import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Col, Row } from "react-bootstrap";
import { MenuSolicitudes } from "../models/MenuSolicitudes";
import CardTabla from "./CardTabla";
import MenuChip from "./MenuChip";
import { getSecurityKey } from "../helpers/SecurityKey";
import { getSolicitudes, getSolicitudSearch } from "../actions/solicitudes";
import { EstatusSolicitudes } from "../models/EstatusSolicitudes";
import {
  eliminacionEspacionPegar,
  FormatoCantidad,
  inputSinEspacios,
} from "../helpers/functionGlobal";

const Solicitudes = ({ actualizaSolicitud }) => {
  const [estatusSolictud, setestatusSolictud] = useState("Todos");

  const dispatch = useDispatch();
  const securityKey = getSecurityKey();

  const dataUser = useSelector((state) => state.auth);
  const sucursalSelec = useSelector((state) => state.sucursalSelection);

  const obtencionSolicitudes = useSelector((state) => state.solicitudes);
  //console.log(dataSolicitudes.GetSolicitudBySucursalDistribuidorResult.GetSolicitudBySucursalDistribuidorResult.lenght);
  //console.log(obtencionSolicitudes);
  const { dataSolicitudes } = obtencionSolicitudes;

  const lastFetchRef = useRef(null);

  useEffect(() => {
    const { user } = dataUser || {};
    const sucursalData = sucursalSelec?.sucursalSeleccionada;
    if (
      !user?.correo ||
      !sucursalData?.Clave ||
      !sucursalData?.CveDistribuidor
    ) {
      return;
    }
    const fetchKey = [
      user.correo,
      sucursalData.CveDistribuidor,
      sucursalData.Clave,
      sucursalData.Vendedor,
      actualizaSolicitud ? "1" : "0",
    ].join("|");
    if (lastFetchRef.current === fetchKey) {
      return;
    }
    lastFetchRef.current = fetchKey;
    dispatch(
      getSolicitudes(
        user.correo,
        sucursalData.CveDistribuidor,
        sucursalData.Clave,
        sucursalData.Vendedor,
        securityKey,
      ),
    );
  }, [dispatch, dataUser, sucursalSelec, actualizaSolicitud]);

  const tipoSolicitudes = (e) => {
    setestatusSolictud(e);
  };

  const buscarSolicitud = () => {
    const textoBuscar = document.getElementsByName("buscarSolicitud")[0].value;
    if (textoBuscar !== "") {
      const { user } = dataUser;
      const { Clave, CveDistribuidor, Vendedor } =
        sucursalSelec.sucursalSeleccionada;
      dispatch(
        getSolicitudSearch(
          user.correo,
          CveDistribuidor,
          Clave,
          Vendedor,
          securityKey,
          textoBuscar,
        ),
      );
    }
  };
  return (
    <>
      <Row className="mt-3">
        <Col xs={2}>
          <h2 className="texto-subtitulo">Créditos</h2>
          <p className="texto-informacion">
            {dataSolicitudes
              ? FormatoCantidad(dataSolicitudes.length, 0, "", ",")
              : 0}
          </p>
        </Col>
        <Form.Group as={Col} className="col-buscador">
          <Form.Control
            type="text"
            name="buscarSolicitud"
            placeholder="Buscar solicitud por nombre apellido parteno o consecutivo"
            maxLength={60}
            autoComplete="off"
            className="input-buscador"
            onKeyDown={(e) => {
              inputSinEspacios(e);
              if (e.key === "Enter") {
                buscarSolicitud();
              }
            }}
            onChange={(e) => {
              eliminacionEspacionPegar(e);
            }}
          />
          <i className="icon-search" onClick={buscarSolicitud}></i>
        </Form.Group>
      </Row>

      <MenuChip items={MenuSolicitudes} onClick={tipoSolicitudes} />

      <CardTabla
        items={dataSolicitudes ? dataSolicitudes : []}
        estatusSelec={estatusSolictud}
        listaEstatus={EstatusSolicitudes}
      />
    </>
  );
};

export default Solicitudes;
